module.exports = __webpack_public_path__ + "static/examp4-17aa83285df0a0f95dfd378c15fbf8fe.gif";